export const GET_PAYMENTS = "GET_PAYMENTS";
export const GET_PAYMENT_BY_ID = "GET_PAYMENT_BY_ID";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
export const DELETE_PAYMENT = "DELETE_PAYMENT";
export const CREATE_PAYMENT = "CREATE_PAYMENT";
